import Vue from 'vue';
import Api from './Api';
import regionsApi from './RegionsApi';
import UomsApi from './UomsApi';
import LengthsApi from './LengthsApi';
import ColorsApi from './ColorsApi';
import InventoryLocationsApi from './InventoryLocationsApi';
import LocationsApi from './LocationsApi';
import InventoryItemsApi from './InventoryItemsApi';
import InventoryTagApi from './InventoryTagsApi';
import ConsumptionsApi from './ConsumptionsApi';
import RecordsApi from './RecordsApi';
import PhysicalCountListApi from './PhysicalCountListApi';
import PhysicalCountApi from './PhysicalCountApi';
import InventoryClassesApi from './InventoryClassesApi';
import jobsApi from './JobsApi';
import clientsApi from './ClientsApi';
import ReportTemplateApi from './Reports/ReportTemplateApi';
import ReportScheduleApi from './Reports/ReportScheduleApi';
import ReportApi from './Reports/ReportApi';
import UserApi from './UsersApi';
import AlertApi from './AlertApi';
import DangerLevelsApi from './DangerLevelsApi';
import ManufacturersApi from './ManufacturersApi';
import FinishingsApi from './FinishingsApi';
import MaterialPropertiesApi from './MaterialPropertiesApi';
import GlassApi from './GlassApi';
import GlassBatchApi from './GlassBatchApi';
import SupplyToPaintApi from './SupplyToPaintApi';
import TruckScheduleRequestApi from './TruckScheduleRequestApi';
import ProductionScheduleApi from './ProductionScheduleApi';
import OrganizationsApi from './OrganizationsApi';
import FileParserApi from './FileParserApi';
import InventoryPoApi from './InventoryPoApi';
import ClientAddressApi from './ClientAddressApi';
import AddressApi from './AddressApi';
import ProjectApi from './ProjectApi';
import PartPickList from './PartPickList';

const factories = {

  user: UserApi,
  address: AddressApi,
  addressType: new Api('addresses/types', 'addresses/types'),
  country: new Api('countries', 'countries'),
  region: regionsApi,
  uom: UomsApi,
  length: LengthsApi,
  color: ColorsApi,
  job: jobsApi,
  jobSubClass: new Api('jobs/sub_classes', 'jobs/sub_classes'),
  client: clientsApi,
  clientAddress: ClientAddressApi,
  alert: AlertApi,
  alertType: new Api('alert_types', 'alert_types'),
  alertProblem: new Api('alert_problems', 'alert_problems'),
  supplier: new Api('suppliers', 'suppliers'),

  location: LocationsApi,
  shelf: new Api('inventory_locations', 'inventory_locations'),

  supplyToLine: ConsumptionsApi,
  supplyToLineRecord: RecordsApi,
  supplyToLineScrapReason: new Api('supply_to_lines/scrap_reasons', 'supply_to_lines/scrap_reasons'),
  physicalCountList: PhysicalCountListApi,
  physicalCount: PhysicalCountApi,

  // inventory
  inventoryMovement: new Api('inventory_movements', 'inventory_movements'),
  inventoryMovementBatch: new Api('inventory_movement_batches', 'inventory_movement_batches'),
  tagToMovementbatch: new Api('tag_to_movement_batches', 'tag_to_movement_batches'),
  inventoryItem: InventoryItemsApi,
  inventoryTag: InventoryTagApi,
  inventoryLocation: InventoryLocationsApi,
  inventoryClass: InventoryClassesApi,
  dangerLevel: DangerLevelsApi,
  inventoryTagNote: new Api('inventory_tags/notes', 'inventory_tags/notes'),
  inventoryTagColumnSetup: new Api('inventory-tag-column-setups', 'inventory-tag-column-setups'),
  inventoryPo: InventoryPoApi,
  inventoryPoItem: new Api('inventory-pos/items', 'inventory-pos/items'),
  inventoryPoExpense: new Api('inventory-pos/expenses', 'inventory-pos/expenses'),
  inventoryPoStatus: new Api('inventory-pos/statuses', 'inventory-pos/statuses'),

  // reports
  reportCategory: new Api('reports/categories', 'reports/categories'),
  reportTemplate: ReportTemplateApi,
  reportSchedule: ReportScheduleApi,
  report: ReportApi,
  reportParameter: new Api('reports/parameters', 'reports/parameters'),
  reportParameterType: new Api('reports/parameter-types', 'reports/parameter-types'),
  reportFileType: new Api('reports/file-types', 'reports/file-types'),
  reportDatabase: new Api('reports/databases', 'reports/databases'),

  // file parser
  fileParser: FileParserApi,
  fileParserFile: new Api('file-parsers/files', 'file-parsers/files'),
  fileParserType: new Api('file-parsers/types', 'file-parsers/types'),
  fileParserFileType: new Api('file-parsers/file-types', 'file-parsers/types'),

  // cut sheet
  cutSheet: new Api('cut-sheets', 'cut-sheets'),
  cutSheetFile: new Api('cut-sheets/files', 'cut-sheets/files'),

  // history
  historyType: new Api('histories/types', 'histories/types'),
  historyModule: new Api('histories/modules', 'histories/modules'),

  // glass
  glass: GlassApi,
  glassBatch: GlassBatchApi,
  glassBatchStatus: new Api('glasses/statuses', 'glasses/statuses'),
  glassCodeMaxQuantity: new Api('glasses/code-max-quantities', 'glasses/code-max-quantities'),
  glassPurchaseOrderItem: new Api('glasses/purchase-order-items', 'glasses/purchase-order-items'),
  glassPoStatus: new Api('glasses/po-statuses', 'glasses/po-statuses'),
  glassSpecification: new Api('glasses/specifications', 'glasses/specifications'),
  glassPaintCode: new Api('glasses/paint-codes', 'glasses/paint-codes'),

  // supply to paint
  supplyToPaint: SupplyToPaintApi,
  supplyToPaintStatus: new Api('supply_to_paints/statuses', 'supply_to_paints/statuses'),

  // truck schedule
  truckScheduleRequest: TruckScheduleRequestApi,
  truckScheduleSlot: new Api('truck-schedules/slots', 'truck-schedules/slots'),
  truckScheduleStatus: new Api('truck-schedules/statuses', 'truck-schedules/statuses'),
  truckScheduleNote: new Api('truck-schedules/notes', 'truck-schedules/notes'),
  truckScheduleTruck: new Api('truck-schedules/trucks', 'truck-schedules/trucks'),
  truckScheduleTruckType: new Api('truck-schedules/truck-types', 'truck-schedules/truck-types'),
  truckScheduleTruckRequestTruck: new Api('truck-schedules/request-trucks', 'truck-schedules/request-trucks'),

  // production schedule
  productionSchedule: ProductionScheduleApi,
  productionScheduleNoteStatus: new Api('production-schedules/note-statuses', 'production-schedules/note-statuses'),
  productionScheduleNote: new Api('production-schedules/notes', 'production-schedules/notes'),

  finishedGood: new Api('finished-goods', 'finished-goods'),

  project: ProjectApi,
  // scope of project
  scopeOfProject: new Api('projects/scope-of-projects', 'projects/scope-of-projects'),
  scopeOfProjectElement: new Api('projects/scope-of-projects/elements', 'projects/scope-of-projects/elements'),

  // doors
  doorHinge: new Api('doors/hinges', 'doors/hinges'),
  doorSwing: new Api('doors/swings', 'doors/swings'),
  doorLite: new Api('doors/lites', 'doors/lites'),
  doorSize: new Api('doors/sizes', 'doors/sizes'),

  // part pick list
  partPickList: PartPickList,
  partPickListItem: new Api('part-pick-lists/items', 'part-pick-lists/items'),
  partPickListStatus: new Api('part-pick-lists/statuses', 'part-pick-lists/statuses'),
  department: new Api('departments', 'departments'),

  // dashboards
  dashboards: new Api('dashboards', 'dashboards'),

  dataImport: new Api('data-imports', 'data-imports'),

  manufacturer: ManufacturersApi,
  finishing: FinishingsApi,
  materialProperty: MaterialPropertiesApi,

  dataSync: new Api('data_sync', 'data_sync'),

  webhook: new Api('webhooks', 'webhooks'),

  adminModule: new Api('admin_modules', 'admin_modules'),

  organization: OrganizationsApi,

};

Vue.prototype.$api = factories;
